export const CHECKOUT_ERROR_CODES = {
    prepaidCard: 'prepaid_card_not_allowed',
    cardPreauthFailed: 'card_preauth_failed',
    paymentDeclined: 'subscription_payment_declined',

    setupIntentFailed: 'setup_intent_failed',
    paymentAuthFailed: 'payment_authentication_failed',
    subscriptionIncomplete: 'subscription_incomplete',
    missingClientSecret: 'missing_payment_client_secret',
    stripeUnavailable: 'stripe_unavailable',

    unknown: 'subscribe_error',
} as const

export type TCheckoutErrorCode = (typeof CHECKOUT_ERROR_CODES)[keyof typeof CHECKOUT_ERROR_CODES]

const BACKEND_ERROR_CODES: TCheckoutErrorCode[] = [
    CHECKOUT_ERROR_CODES.prepaidCard,
    CHECKOUT_ERROR_CODES.cardPreauthFailed,
    CHECKOUT_ERROR_CODES.paymentDeclined,
]

export const isBackendErrorCode = (code: string | undefined): code is TCheckoutErrorCode =>
    BACKEND_ERROR_CODES.some(known => known === code)
